<template>
  <div class="acomodar">
      <BasePostulante/>
  </div>
</template>

<script>
import BasePostulante from "@/components/ModSeleccion/Postulante/BasePostulante.vue";
import '@/assets/styles/global-acomodar.css'; // Importar el estilo global

export default {
  name: "SolimanologListado",
  data() {
      return {};
  },
  mounted() {
  },

  created(){
      this.cambiarEstadoNavbar()
  },
  methods: {
      
  cambiarEstadoNavbar() {
    // Acción directa para cambiar el estado del navbar a true
    this.$store.dispatch('acciones/CambioNavbar', true);
  }

  },
  components: { BasePostulante } 
};
</script>

<style scoped>

</style>
